import React from 'react'
import { observer } from 'mobx-react-lite'

import { Link, TableCell } from '@material-ui/core'

import { formatShipmentDatesRange } from '../common/dateTimeUtility'

import { MyRowProps } from '../types/tableTypes'
import { PrintFileGroupModel } from '../server/mpsklad_core/Models/PrintFileGroupModel'

export type PrintFileCellProps =
  MyRowProps<PrintFileGroupModel> & {
  makeLabelsUrl: (fileId: string) => string

  makePurchaseListUrl: (fileId: string) => string
  makeMsBarcodesUrl: (fileId: string) => string
}

const purchaseListStartDateUnix = 1734440640 /* 17-Dec-24 at 16:04 */
const msBarcodesStartDateUnix = 1740133787 /* 21-Feb-2025 at 10:29 */

export const PrintFileCell =
  observer(
    ({row, makeLabelsUrl, makePurchaseListUrl, makeMsBarcodesUrl}: PrintFileCellProps) => {
      const datesRangeText = formatShipmentDatesRange(row)

      return (
        <TableCell className="table-border">
          <Link href={makeLabelsUrl(row.labelsFileId)} target="_blank" underline="always">
            Этикетки от {datesRangeText}
          </Link>

          {
            row.isLegacy
            ? row.createdAt > purchaseListStartDateUnix &&
              <>
                <br/>
                <Link href={makePurchaseListUrl(row.labelsFileId)} target="_blank" underline="always">
                  Лист подбора от {datesRangeText}
                </Link>
              </>
            : row.purchaseListFileId != null &&
              <>
                <br/>
                <Link href={makePurchaseListUrl(row.purchaseListFileId)} target="_blank" underline="always">
                  Лист подбора от {datesRangeText}
                </Link>
              </>
          }

          {
            row.isLegacy
            ? row.createdAt > msBarcodesStartDateUnix &&
              <>
                <br/>
                <Link href={makeMsBarcodesUrl(row.labelsFileId)} target="_blank" underline="always">
                  Штрихкоды товаров в МоёмСкладе от {datesRangeText}
                </Link>
              </>
            : row.msBarcodesFileId != null &&
              <>
                <br/>
                <Link href={makeMsBarcodesUrl(row.msBarcodesFileId)} target="_blank" underline="always">
                  Штрихкоды товаров в МоёмСкладе от {datesRangeText}
                </Link>
              </>
          }
        </TableCell>
      )
    })